'use client'

import { createContext, useContext, type ReactNode } from 'react'
import { useNavigationLive } from '@/hooks/navigation/useNavigationLive'

/** `true` só depois do ack `ok` do `enter_navigation` nesta conexão. Default
 *  `false`: fora do provider nenhuma query de navegação dispara. */
const NavigationJoinedContext = createContext(false)

/**
 * Monta o `useNavigationLive` UMA vez (em `PrivateProviders`) e publica o `joined`
 * que libera a query do retrato (`useNavigationSnapshot`). Duas montagens emitiriam
 * enter/leave em dobro e o leave de uma tiraria a sala do socket da outra.
 */
export function NavigationProvider({ children }: { children: ReactNode }) {
  const joined = useNavigationLive()
  return <NavigationJoinedContext.Provider value={joined}>{children}</NavigationJoinedContext.Provider>
}

export const useNavigationJoined = (): boolean => useContext(NavigationJoinedContext)
